import {type FC, useCallback} from 'react';

import {useI18n} from '@yourcoach/i18n';

import type {ConferenceType} from '../../../book-conference/types';

import {envManager} from '../../../../utils/env';
import {useWindowDimensions} from '../../../../utils/hooks/useWindowDimensions';
import {logger} from '../../../../utils/logger';
import * as S from './styles';

type Props = {
  duration: number;
  onTypeClick: (type: ConferenceType) => void;
};

export const ConferenceTypePicker: FC<Props> = ({duration, onTypeClick}) => {
  const {t} = useI18n();
  const {width: ww} = useWindowDimensions();

  const isB2bWidget = envManager.isB2bWidget;

  const onTypeClickCb = useCallback(
    (type: ConferenceType) => {
      logger.event('session_schedule_select_type_tap', {
        session_type: type === 'chat' ? 'chat_session' : 'video_session',
      });

      onTypeClick(type);
    },
    [onTypeClick],
  );

  const isSmallUI = ww >= 320 && ww < 440;

  return (
    <S.Container>
      <S.SessionTypeContainer isB2bWidget={isB2bWidget}>
        <S.SessionTypeContent isSmallUI={isSmallUI}>
          <S.Title isB2bWidget={isB2bWidget} isSmallUI={isSmallUI}>
            {t('shared:live_voice_video_session')}
          </S.Title>
          <S.Description isSmallUI={isSmallUI}>
            {t('shared:book_live_session_description.live', {
              duration: duration || 30,
            })}
          </S.Description>
          <S.ScheduleButton
            isB2bWidget={isB2bWidget}
            isSmallUI={isSmallUI}
            onClick={() => onTypeClickCb('live')}
          >
            {t('shared:schedule')}
          </S.ScheduleButton>
        </S.SessionTypeContent>
        <S.LiveIcon $isB2bWidget={isB2bWidget} $isSmallUI={isSmallUI} />
      </S.SessionTypeContainer>
      <S.SessionTypeContainer isB2bWidget={isB2bWidget}>
        <S.SessionTypeContent isSmallUI={isSmallUI}>
          <S.Title isB2bWidget={isB2bWidget} isSmallUI={isSmallUI}>
            {t('shared:real_time_chat_session')}
          </S.Title>
          <S.Description isSmallUI={isSmallUI}>
            {t('shared:book_live_session_description.chat', {
              duration: duration || 30,
            })}
          </S.Description>
          <S.ScheduleButton
            isB2bWidget={isB2bWidget}
            isSmallUI={isSmallUI}
            onClick={() => onTypeClickCb('chat')}
          >
            {t('shared:schedule')}
          </S.ScheduleButton>
        </S.SessionTypeContent>
        <S.ChatIcon $isB2bWidget={isB2bWidget} $isSmallUI={isSmallUI} />
      </S.SessionTypeContainer>
    </S.Container>
  );
};
